/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import twofactorApp from './app/2fa.app.module.js';
import twofactorEmail from './email/2fa.email.module.js';
import twofactorProductApp from './productapp/2fa.productapp.module.js';
import twofactorOtp from './otp/2fa.otp.module.js';
import twofactorConfirmation from './confirmation/2fa.confirmation.module.js';
import twofactorSce from './sce/2fa.sce.module.js';
import twofaConfig from './2fa.config.js';
import twofaRoute from './2fa.route.js';
import twofaController from './2fa.controller.js';
import twofatypeSelector from './twofatypeselector/twofatypeSelector.js';


/**
 * This is the 2fa module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace 2fa Module
 */
angular.module('twofactor', [
  // Shared modules.
  core,
  twofactorApp,
  twofactorEmail,
  twofactorProductApp,
  twofactorOtp,
  twofactorSce,
  twofactorConfirmation
])
// Register config.
.config(twofaConfig)
// Register route.
.config(twofaRoute)
// Register controller.
.controller('twofaController', twofaController)

.directive('twofatypeSelector', twofatypeSelector);

export default 'twofactor';


// WEBPACK FOOTER //
// ./src/login/2fa/2fa.module.js